__turbopack_context__.v({
  "buttonsWrapper": "_E95vq_buttonsWrapper",
  "mergeModalProduct": "_E95vq_mergeModalProduct",
  "productName": "_E95vq_productName",
  "productQuantity": "_E95vq_productQuantity",
});
